// extracted by mini-css-extract-plugin
export var active = "burger-module--active--f7f97";
export var burger = "burger-module--burger--eb1f6";